@if (message) {
  <div class="flex pad-vertical-16 items-center">
    <span class="success-400-text icon-money pad-right-10"></span> {{ message }}
  </div>
}
